import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PopupAd = ({ image, link, storageKey = "popup-ad-seen" }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const alreadySeen = sessionStorage.getItem(storageKey);
        if (alreadySeen) return;

        const timer = setTimeout(() => {
            setShow(true);
            sessionStorage.setItem(storageKey, "true");
        }, 800);

        return () => clearTimeout(timer);
    }, [storageKey]);

    const onClose = () => setShow(false);

    return (
        <div className={`popup-ad-wrapper ${show ? "active" : ""}`}>
            <div className="popup-ad-overlay" onClick={onClose}></div>
            <div className="popup-ad-content">
                <button className="popup-ad-close" onClick={onClose}>
                    <i className="icofont-close-line"></i>
                </button>
                <Link to={`${process.env.PUBLIC_URL}${link}`} onClick={onClose}>
                    <img src={`${process.env.PUBLIC_URL}${image}`} alt="Iklan Turnamen" />
                </Link>
            </div>
        </div>
    );
};

PopupAd.propTypes = {
    image: PropTypes.string,
    link: PropTypes.string,
    storageKey: PropTypes.string,
};

export default PopupAd;
